var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from "react";
import { findDefaultRoute, findMatchingRoute, findRootRoute } from "./services/utils";
import { useLocation } from "./services/hooks";
var RouteContext = createContext(null);
/**
 * This component conatins all the routes and is responsible of selecting the relevant one to render.
 */
var Routes = function (_a) {
    var children = _a.children;
    var _b = useLocation(), pathName = _b.pathName, queryParams = _b.queryParams;
    var route = pathName === "/" ? findRootRoute(children) : findMatchingRoute(children, pathName);
    route = route || findDefaultRoute(children);
    if (route === null)
        return null;
    return _jsx(RouteContext.Provider, { value: { params: __assign(__assign({}, route.params), queryParams) }, children: _jsx(route.component, {}) });
};
export { Routes, RouteContext };
